import { useState } from "react";
import { baseUrl } from "@app/query.ts";
import { Alert, Button, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const RequestSignInLink = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async () => {
    setStatus("loading");
    setErrorMessage("");

    try {
      const response = await fetch(baseUrl + "/v2/auth/request-sign-in-link", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const errorData: {
          message: string;
        } = (await response.json()) as { message: string };
        setErrorMessage(errorData.message || "An error occurred.");
        setStatus("error");
      } else {
        setStatus("success");
      }
    } catch (_) {
      setErrorMessage("Network error.");
      setStatus("error");
    }
  };

  return (
    <Stack padding={4} spacing={4}>
      <Typography variant="h5">{t("requestSignIn.title")}</Typography>
      {status === "success" ? (
        <Alert>{t("requestSignIn.success")}</Alert>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            void handleSubmit();
          }}
        >
          <Stack spacing={2}>
            <TextField
              onChange={(event) => {
                setEmail(event.target.value);
              }}
              label={t("requestSignIn.email")}
            />

            <Button
              disabled={!email}
              loading={status === "loading"}
              type="submit"
              variant="contained"
              sx={{ width: "fit-content", marginLeft: "auto !important" }}
            >
              {t("requestSignIn.submit")}
            </Button>
            {status === "error" && (
              <div className="text-red-600">{errorMessage}</div>
            )}
          </Stack>
        </form>
      )}
    </Stack>
  );
};

export default RequestSignInLink;
